module.exports = __webpack_public_path__ + "static/media/Mar5-S20.f24af24b.png";